const storeConfig = {
    store: {
        filterLayout: 'StoreFilterDefaultLayout',
        listLayout: 'StoreListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getStoreList',
        deleteFunc: 'deleteStore',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteSuccessMsg: '삭제가 완료되었습니다.',
        listFailMsg: '데이터를 불러올 수 없습니다.',
        deleteFailMsg: '삭제에 실패하였습니다.',
        keyName: 's_idx',
    },
    writeStore: {
        writeLayouts: ['StoreWriteDefaultLayout'],
        writeFunc: 'createStore',
        writeApiParamSet: {
        },
        getCategoryFunc: '',
        parsingData: {
            title: 's_name',
            link: 's_link',
            minPoint: 's_point'
        },
        keyName: '',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 등록할 수 없습니다.',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'mainImage',
                fileType: 'store',
                required: true,
                validatorMsg: '메인 이미지를 추가해주세요.',
            },
        ],
    },
}
export default {
    methods: {
        returnStoreConfig(type) {
            return storeConfig[type];
        },
    },
    filterConfig: {
        na: { // 제목
            type: 'query',
            classname: 'searchInput',
        },
    },
}
